import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import modalCss from '../../../../components/modals/modal.module.css';
import css from '../index.module.css';

export default function ValidationModal({
  content,
  title,
  buttons,
  visible = true,
  onClose,
}: {
  content?: string | ReactNode;
  title?: string | ReactNode;
  buttons?: ReactNode[] | null;
  visible?: boolean;
  onClose: () => void;
}) {
  const [modalVisible, setModalVisible] = useState(visible);
  useEffect(() => setModalVisible(visible), [visible]);

  const closeModal = useCallback(() => {
    setModalVisible(false);
    onClose();
  }, [setModalVisible, onClose]);

  return (
    <ReactModal
      isOpen={modalVisible}
      onRequestClose={closeModal}
      className={css['validation-modal']}
      overlayClassName={modalCss['overlay']}
      shouldCloseOnOverlayClick={true}
    >
      <div className={css['content']} data-name="validation-modal">
        {title && <h1 className={modalCss['title']}>{title}</h1>}
        {content && <div className={modalCss['message']}>{content}</div>}
        {buttons && <div className={modalCss['buttons']}>{buttons}</div>}
      </div>
    </ReactModal>
  );
}
